
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkBudgetAccountTypeEnum } from '../models/work-budget-account-type-enum';
import { WorkBudgetIstSourceEnum } from '../models/work-budget-ist-source-enum';
import { WorkBudgetSollSourceEnum } from '../models/work-budget-soll-source-enum';
import { requiredBoolean } from './required-boolean.validator';
import { WorkBudgetEntry } from '../models/work-budget-entry';

export function getBudgetAccountFormGroup() {
return new FormGroup({
    id: new FormControl<number | undefined>(undefined, [Validators.required]),
    created: new FormControl<string | undefined>(undefined),
    modified: new FormControl<string | undefined>(undefined),
    name: new FormControl<string | undefined>('', [Validators.required]),
    accountType: new FormControl<WorkBudgetAccountTypeEnum | undefined>(undefined, [Validators.required]),
    istSource: new FormControl<WorkBudgetIstSourceEnum | undefined>(undefined),
    sollSource: new FormControl<WorkBudgetSollSourceEnum | undefined>(undefined),
    isAdditive: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    sortableRank: new FormControl<number | undefined>(undefined, [Validators.required]),
    active: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    createdBy: new FormControl<number | undefined>(undefined),
    modifiedBy: new FormControl<number | undefined>(undefined),
    budgetEntries: new FormControl<WorkBudgetEntry[]>([]),
})
;
}
      